import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { BRAND } from "@/lib/brand";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const data = await login(email, password);
      toast.success("Hoş geldiniz");
      navigate(data.user?.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="theme-dash min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs tracking-[0.24em] text-neutral-500 mb-10 inline-block" data-testid="login-brand">{BRAND.wordmark}</Link>
        <h1 className="font-editorial text-4xl mb-2">Barber girişi</h1>
        <p className="text-neutral-500 text-sm mb-10">Panelinize erişmek için giriş yapın.</p>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="block text-xs uppercase tracking-widest text-neutral-500 mb-2">E-posta</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 bg-white border border-neutral-200 rounded-none focus:outline-none focus:border-neutral-900 transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-neutral-500 mb-2">Şifre</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 bg-white border border-neutral-200 rounded-none focus:outline-none focus:border-neutral-900 transition-colors"
            />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="login-error">{error}</div>}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full py-4 bg-neutral-900 text-white font-medium tracking-wide hover:bg-neutral-800 transition-colors disabled:opacity-60"
          >
            {busy ? "Giriş yapılıyor…" : "Giriş yap"}
          </button>
        </form>

      </div>
    </div>
  );
}
